import React from "react";

import {
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Button,
  Avatar,
  createMuiTheme,
  CircularProgress,
  Typography,
  Divider,
  Box,
  Grid,
  Paper,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { makeStyles, ThemeProvider, useTheme } from "@material-ui/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRocket, faDirections } from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  addButton: {
    borderRadius: "50%",
  },
  addIcon: {
    fontSize: "14.5rem",
    color: theme.palette.secondary.main,
  },
  addText: {
    padding: 20,
  },
  cardRoot: {
    width: "100%",
    padding: 24,
    maxHeight: 410,
    height: "100%"
  },
}));

const AccountItem = (props) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Grid item md={6} xs={12} sm={12}>
      <Card className={classes.cardRoot}>
        <div className={classes.root}>
          <ThemeProvider
            theme={createMuiTheme({
              palette: {
                type: "dark",
                primary: {
                  main: theme.palette.secondary.main,
                },
                text: {
                  secondary: theme.palette.primary.main,
                },
              },
            })}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                className={classes.addButton}
                onClick={() =>
                  window.open(
                    "https://www.natro.com/hosting/wordpress-hosting",
                    "_blank"
                  )
                }
              >
                <AddIcon className={classes.addIcon}></AddIcon>
              </Button>
            </div>
            <div>
              <Typography className={classes.addText} variant="h5">
                {t("Add New Packet")}
              </Typography>
            </div>
          </ThemeProvider>
        </div>
      </Card>
    </Grid>
  );
};

export default AccountItem;
